import React, { useState } from 'react';
import { DISTRIBUTORUSERTYPE } from '../../../../../constants/selects';
import Input from '../../../../atoms/input';
import SelectCustom from '../../../../atoms/selectCustom';
import { useForm } from 'react-hook-form';
import ButtonComponent from '../../../../atoms/button';
import { Grid, IconButton } from '@material-ui/core';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ReactComponent as IconDelete } from '../../../../../assets/icons/icon-cross-circle-white.svg';
import { toast } from 'react-toastify';
import Typography from '../../../../atoms/typography';
import { v4 as uuidv4 } from 'uuid';
import useBulkCreateDistributorUsers from '../../../../../hooks/distributorUser/useBulkCreateDistributorUsers';
import schema, { formSchemaType } from './schema';
import { yupResolver } from '@hookform/resolvers/yup';
import { emailValidator } from '../../../../../services/mask';

const FormCreateDistributorUser: React.FC<any> = ({ onClick }: any) => {
  const { execute } = useBulkCreateDistributorUsers();
  const { control, setValue } = useForm<formSchemaType>({
    resolver: yupResolver(schema),
    mode: 'onChange',
    defaultValues: {
      username: '',
      email: '',
    },
  });
  const [distributorUsers, setDistributorUsers] = useState([
    {
      id: uuidv4(),
      username: '',
      email: '',
      password: '',
      distributorUserType: DISTRIBUTORUSERTYPE[1].value,
      status: '',
    },
  ]);

  const validateUserFields = (user: any) => {
    return user.username && user.email && user.distributorUserType;
  };

  const addDistributorUser = () => {
    if (distributorUsers.length >= 5) {
      toast.error('Número máximo de usuários atingido.');
      return;
    }

    if (!validateUserFields(distributorUsers[distributorUsers.length - 1])) {
      toast.warn(
        'Por favor, preencha todos os campos do usuário atual antes de adicionar um novo.',
      );
      return;
    }

    setDistributorUsers([
      ...distributorUsers,
      {
        id: uuidv4(),
        username: '',
        email: '',
        password: '',
        distributorUserType: DISTRIBUTORUSERTYPE[1].value,
        status: '',
      },
    ]);
  };

  const saveDistributorUser = async () => {
    const invalidEmail = distributorUsers.some(
      user => !emailValidator(user.email),
    );

    if (
      distributorUsers.some(user => !validateUserFields(user)) &&
      !invalidEmail
    ) {
      toast.error(
        'Por favor, preencha todos os campos para todos os usuários.',
      );
    } else {
      await execute(
        [...distributorUsers].map(item => ({
          email: item.email,
          username: item.username,
          distributorUserType: item.distributorUserType,
        })),
      );
      toast.success('Usuários criados com sucesso.');
    }
  };

  const deleteDistributorUser = (id: string) => {
    if (distributorUsers.length === 1) {
      toast.error('Não é possível excluir o último usuário.');
      return;
    }

    try {
      setDistributorUsers(prevUsers =>
        prevUsers.filter(user => user.id !== id),
      );
      toast.success('Usuário excluído com sucesso.');
    } catch (error) {
      console.error(error);
      toast.error('Erro ao excluir o usuário.');
    }
  };

  return (
    <>
      <Typography fontWeight="700" color="secondary" mb={3}>
        Novo usuário
      </Typography>
      {distributorUsers.map((distributorUser, index) => (
        <Grid container spacing={2} key={distributorUser.id}>
          <Grid item xs={4}>
            <Input
              size="small"
              label={'Nome'}
              placeholder="Bento Luiz Ricardo Farias"
              name="name"
              control={control}
              maxLength={50}
              value={distributorUser.username}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                const newDistributorUsers = [...distributorUsers];
                newDistributorUsers[index].username = event.target.value;
                setDistributorUsers(newDistributorUsers);
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <Input
              size="small"
              label={'E-mail'}
              placeholder="distributor@fretapp.com.br"
              name="email"
              control={control}
              maxLength={50}
              value={distributorUser.email}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                const newDistributorUsers = [...distributorUsers];
                newDistributorUsers[index].email = event.target.value;
                setDistributorUsers(newDistributorUsers);
              }}
            />
          </Grid>
          <Grid item xs={3}>
            <SelectCustom
              defaultValue="Básico"
              label={'Tipo'}
              placeholder="Básico"
              size="small"
              value={distributorUser.distributorUserType}
              onChange={(event: any) => {
                const newDistributorUsers = [...distributorUsers];
                newDistributorUsers[index].distributorUserType =
                  event.target.value;
                setDistributorUsers(newDistributorUsers);
              }}
              options={DISTRIBUTORUSERTYPE.map(
                (item: { name: string; value: string }) => ({
                  label: item.name,
                  value: item.value,
                }),
              )}
            />
          </Grid>

          <Grid item xs={1}>
            <ButtonComponent
              theme="primary"
              mt={6}
              justifyContent="none"
              onClick={() => deleteDistributorUser(distributorUser.id)}
            >
              <IconButton>
                <IconDelete />
              </IconButton>
            </ButtonComponent>
          </Grid>
        </Grid>
      ))}
      <br />
      {[...distributorUsers].length < 5 && (
        <ButtonComponent
          theme="primary"
          onClick={addDistributorUser}
          size="small"
          mb={5}
          style={{ height: '50%' }}
        >
          <FontAwesomeIcon
            icon={solid('plus')}
            size="sm"
            color="#fff"
            style={{ marginRight: 5 }}
          />
          Adicionar Usuário
        </ButtonComponent>
      )}

      <Grid container justifyContent="space-between" style={{ marginTop: 20 }}>
        <ButtonComponent
          theme="outline-primary"
          justifyContent="flex-start"
          flex={1}
          onClick={() => onClick('')}
        >
          Cancelar
        </ButtonComponent>
        <ButtonComponent
          onClick={saveDistributorUser}
          theme="primary"
          justifyContent="flex-end"
          flex={1}
        >
          Salvar alterações
        </ButtonComponent>
      </Grid>
    </>
  );
};

export default FormCreateDistributorUser;
